import { render, staticRenderFns } from "./en.vue?vue&type=template&id=391f2a6a&scoped=true&lang=html&"
import script from "./en.vue?vue&type=script&lang=js&"
export * from "./en.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "391f2a6a",
  null
  
)

export default component.exports